//两数组比较qu'chong
const removeSameItem = (arr1, arr2) => {
  let temp = []; //临时数组1
  let temparray = [];//临时数组2

  for (let i = 0; i < arr2.length; i++) {
    temp[arr2[i].id] = true;//巧妙地方：把数组B的值当成临时数组1的键并赋值为真
  }

  for (let i = 0; i < arr1.length; i++) {
    if (!temp[arr1[i].id]) {
      temparray.push(arr1[i]);//巧妙地方：同时把数组A的值当成临时数组1的键并判断是否为真，如果不为真说明没重复，就合并到一个新数组里，这样就可以得到一个全新并无重复的数组
    }
  }
  return temparray
}
//判断商品内属性值是否有空
const isEmptyValInObject = (obj) => {
  let flag = false;
  for (let key in obj) {
    //   if(key != 'imageUrls' ||key != 'imageUrlsExist' ||key != 'detailImageUrls' ||key != 'detailImageUrlsExist' ){
    if (obj[key] === '' || obj[key] == undefined) {
      if (key == 'imageUrls' || key == 'imageUrlsExist' || key == 'detailImageUrls' || key == 'detailImageUrlsExist') {
        continue;
      } else {
        flag = true;
        break;
      }

      // }
    }
    if (key == "attributes") {
      for (let i = 0; i < obj[key].length; i++) {
        if (obj[key][i].val == '') {
          flag = true;
          break;
        }
      }
    }

  }
  return flag;
}
//判断商品内图片是否为口是否有空
const isEmptyImgInObject = (obj) => {
  let flag = false;
  if ((obj.imageUrls.length == 0 && obj.imageUrlsExist.length == 0) || (obj.detailImageUrls.length == 0 && obj.detailImageUrlsExist.length == 0)) {
    flag = true
  }
  return flag;
}
//批量设置商品
const batchSetProduct = (arr, obj, selectArr) => {
  arr.map(item => {
    if (selectArr.indexOf(item.id) != -1) {
      item['deliverTime'] = obj['deliverTime'];
      item['isConfirm'] = obj['isConfirm']
      item['minOrderQuantity'] = obj['minOrderQuantity']
      item['skuStock'] = obj['skuStock']
      item['unitVal'].unitId = obj['unitId']
      item['unitVal'].unitValue = obj['unitValue']
      item['deliveryType'] = obj['deliveryType']
    }

  })
}
const getOneDimensionArr = (arr) => {
  let temArr = [];
  for (let i = 0; i < arr.length; i++) {
    temArr.push(arr[i].id)
  }
  return temArr;
}
//判断批量发布规格不能为空
const isEmptyAttr = (arr) => {
  let flag = false
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].length == 0) {
      flag = true;
      break;
    }
    for (let j = 0; j < arr[i][j].length; j++) {
      if (arr[i][j].attributeValue == '' || arr[i][j].unitValue == '') {
        flag = true;
        break;
      }
    }
  }
  return flag;
}
export function getIndexInArr(arr, attr, val) {
  let index = -1;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][attr] == val) {
      index = i;
      break
    }
  }
  return index
}
export default { removeSameItem, isEmptyValInObject, isEmptyImgInObject, batchSetProduct, getOneDimensionArr, isEmptyAttr, getIndexInArr }